import * as React from 'react';
import { CSSProperties } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import { IRootState } from 'reducer';

interface IStylingProps {
  isFullSize: boolean;
}

const StyledPanel = styled.div<IStylingProps>`
  height: 41px;
  width: 100%;
  position: fixed;
  z-index: 1;
  background: #f4f4f4;
  @media (min-width: 816px) {
    padding-left: ${(props) =>
      props.isFullSize ? 'calc(255px + 32px)' : '32px'};
  }
`;

interface IProps {
  isFullSize: boolean;
  style?: CSSProperties;
}

const TopPanel: React.FC<IProps> = ({ isFullSize, children, ...props }) => {
  return (
    <StyledPanel {...props} isFullSize={isFullSize}>
      {children}
    </StyledPanel>
  );
};

const mapStateToProps = ({ app }: IRootState) => ({
  isFullSize: app.isSideBarOpen,
});

export default connect(mapStateToProps)(TopPanel);

export { default as ModeButton } from './components/ModeButton'
export { default as NavTopPanel } from './components/SeconPanel';